export const SIGN_UP_COOKIES_LIFETIME = 7200; // 2 часа в секундах
export const SIGN_UP_SESSION_LIFETIME = 7200; // 2 часа в секундах

export const SESSION_LIFETIME = 24 * 60 * 60; // 24 часа
export const SESSION_COOKIE_LIFETIME = 24 * 60 * 60;

export const ANALYTICS_CONSENT_LIFETIME = 60 * 60 * 24 * 365; // 1 год

export const CHECK_SESSION_INTERVAL = 5 * 60 * 1000; // 5 минут
export const CHECK_SIGN_UP_SESSION_INTERVAL = 5 * 60 * 1000;

export const VK_REFRESH_TOKEN_LIFETIME = 180 * 24 * 60 * 60 * 1000;

export const FEATURE_FLAG_TTL_SECONDS = 86400; // 24 часа
